"use client";

import { lazy, type ReactNode } from "react";
import { afterInitialPaintOrInteraction } from "@/lib/after-initial-paint";
import { HydrationReady } from "./hydration-ready";

const IntlProvider = lazy(async () => {
  if (typeof window !== "undefined") {
    await new Promise<void>((resolve) => afterInitialPaintOrInteraction(resolve));
  }
  return { default: (await import("./intl-provider")).IntlProvider };
});

export function LocaleProvider({ locale, timeZone, children }: {
  locale: string;
  timeZone: string;
  children: ReactNode;
}) {
  // Let the server finish this shell before sending it. A local null fallback
  // would hide the rendered page until React's client runtime reveals it.
  return (
    <IntlProvider locale={locale} timeZone={timeZone}>
      <HydrationReady>{children}</HydrationReady>
    </IntlProvider>
  );
}
